import { Img } from "containers/Manual/components/content/Image";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";

export const TRIMRIGHT = () => {
  return (
    <CardSection id="TRIMRIGHT" title="TRIMRIGHT">
      <Paragraph>
        문자열의 오른쪽 끝의 공백을 제거한 문자열을 반환합니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>TRIMRIGHT(STRING)</Paragraph>
        <Ul>
          <Li>
            <b>STRING</b>은 트리밍하려는 값입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>TRIMRIGHT(`product`)</Paragraph>
        <Img src="computeTrimRight" />
      </ListSection>
    </CardSection>
  );
};
